import React from 'react';
import AccommodationCarousel from '../AccommodationCarousel';
import '../Section.css';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations';

import '../../App.css';
import './AccommodationPage.css';
function AccommodationPage() {
  const { language } = useLanguage();
  const bookingUrl = "https://www.airbnb.com/rooms/1165889476225381967";

  return (
    <div className="page accommodation-page">
      {/* Carousel comes first */}
      <div className="halftone-bg xfade-section">
        <AccommodationCarousel />
      </div>

      {/* Full-width black text panel with title and description only */}
      <div className="full-width-text-panel" style={{marginTop: '0', textAlign: 'center'}}>
        <h3 style={{fontSize: '1.4rem', marginBottom: '1rem', fontFamily: 'Jost, sans-serif'}}>{t('accommodation.title', language)}</h3>
        <p>
          <i>{t('accommodation.description', language)}</i>
        </p>
      </div>

      {/* Content on halftone background - separate from black panel */}
      <div style={{
        maxWidth: '1200px',
        margin: '2rem auto',
        padding: '0 2rem',
        textAlign: 'center'
      }}>
        {/* Book now button */}
        <a
          href={bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="book-now-btn"
          style={{
            fontSize: '1.3rem',
            padding: '0.8rem 1.8rem',
            marginBottom: '1.5rem',
            display: 'inline-block'
          }}
        >
          {t('accommodation.bookNow', language)}
        </a>

        {/* Additional text */}
        <p style={{
          marginTop: '1.5rem',
          fontSize: '1.2rem',
          fontWeight: '500',
          color: '#191919',
          fontFamily: "'Jost', 'Futura', sans-serif"
        }}>
          {t('accommodation.otherOptions', language)}
        </p>
      </div>
    </div>
  );
}

export default AccommodationPage;
